import { SeasonSponsor } from "./leagueInterfaces";

export const formatTeam = (team: any) => {
  const members: TeamMember[] = [];
  if (team.ownersColl) {
    team.ownersColl.forEach((owner: any) => {
      const existing = members.find((m) => m.id === owner.id);
      if (existing) {
        existing.isOwner = true;
        return;
      } else {
        members.push({
          id: owner.playerId,
          title: owner.title,
          firstName: owner.firstName,
          lastName: owner.lastName,
          profilePicture: owner.profilePicture,
          role: owner.role,
          email: owner.email,
          phone: owner.phone,
          isPlayer: false,
          isCaptain: false,
          isOwner: true,
          isCoreMember: false,
          isShortListed: false,
        });
      }
    });
  }

  if (team.captain) {
    const existing = members.find((m) => m.id === team.captain.playerId);
    if (existing) {
      existing.isCaptain = true;
      existing.playerHandicap = team.captain.playerHandicap;
      existing.homeClub = team.captain.homeClub;
      existing.ageCategory = team.captain.ageCategory;
      existing.gender = team.captain.gender;
    } else {
      members.push({
        id: team.captain.playerId,
        title: team.captain.title,
        firstName: team.captain.firstName,
        lastName: team.captain.lastName,
        profilePicture: team.captain.profilePicture,
        playerHandicap: team.captain.playerHandicap,
        homeClub: team.captain.homeClub,
        ageCategory: team.captain.ageCategory,
        gender: team.captain.gender,
        role: team.captain.role,
        email: team.captain.email,
        phone: team.captain.phone,
        isPlayer: false,
        isCaptain: true,
        isOwner: false,
        isCoreMember: false,
        isShortListed: false,
      });
    }
  }

  if (team.coreMembersColl) {
    team.coreMembersColl.forEach((member: any) => {
      const existing = members.find((m) => m.id === member.playerId);
      if (existing) {
        existing.isCoreMember = true;
        existing.playerHandicap = member.playerHandicap;
        existing.homeClub = member.homeClub;
        existing.ageCategory = member.ageCategory;
        existing.gender = member.gender;
      } else {
        members.push({
          id: member.playerId,
          title: member.title,
          firstName: member.firstName,
          lastName: member.lastName,
          profilePicture: member.profilePicture,
          role: member.role,
          playerHandicap: member.playerHandicap,
          homeClub: member.homeClub,
          ageCategory: member.ageCategory,
          gender: member.gender,
          email: member.email,
          phone: member.phone,
          isPlayer: false,
          isCaptain: false,
          isOwner: false,
          isCoreMember: true,
          isShortListed: false,
        });
      }
    });
  }

  if (team.playersColl) {
    team.playersColl.forEach((player: any) => {
      const existing = members.find((m) => m.id === player.playerId);
      if (existing) {
        existing.isPlayer = true;
        existing.playerHandicap = player.playerHandicap;
        existing.homeClub = player.homeClub;
        existing.ageCategory = player.ageCategory;
        existing.gender = player.gender;
      } else {
        members.push({
          id: player.playerId,
          title: player.title,
          firstName: player.firstName,
          lastName: player.lastName,
          profilePicture: player.profilePicture,
          role: player.role,
          playerHandicap: player.playerHandicap,
          homeClub: player.homeClub,
          ageCategory: player.ageCategory,
          gender: player.gender,
          email: player.email,
          phone: player.phone,
          isPlayer: true,
          isCaptain: false,
          isOwner: false,
          isCoreMember: false,
          isShortListed: false,
        });
      }
    });
  }

  members.sort((a, b) => {
    if (a.isOwner !== b.isOwner) {
      return a.isOwner ? -1 : 1;
    }
    if (a.isPlayer !== b.isPlayer) {
      return a.isPlayer ? 1 : -1;
    }
    if (a.isCaptain !== b.isCaptain) {
      return a.isCaptain ? -1 : 1;
    }
    if (a.isCoreMember !== b.isCoreMember) {
      return a.isCoreMember ? -1 : 1;
    }
    if (a.isShortListed !== b.isShortListed) {
      return a.isShortListed ? -1 : 1;
    }
    return 0;
  });

  if (team.shortlistedPlayersColl) {
    team.shortlistedPlayersColl.forEach((player: any) => {
      player.fullName = `${player.title} ${player.firstName} ${player.lastName}`;
    });
  }
  return {
    ...team,
    members,
  };
};

export const formatTeams = (teams: any[]) => {
  return teams.map((t) => formatTeam(t));
};
export interface UserDetailsViewOnly {
  playerId: string;
  title: string;
  firstName: string;
  lastName: string;
  profilePicture: string;
  role: string;
  id: string;
  name: string;
  email: string;
}

export interface PlayerDetailsViewOnly {
  playerId: string;
  title: string;
  firstName: string;
  lastName: string;
  profilePicture: string;
  role: string;
  playerHandicap: string;
  homeClub: string;
  seasonId: string;
  teamName: string;
  gender: string;
  ageCategory: string;
  preferredDates: string[];
}

export interface TeamMember {
  id: string;
  title: string;
  firstName: string;
  lastName: string;
  profilePicture: string;
  role: string;
  playerHandicap?: string;
  homeClub?: string;
  ageCategory?: "Senior" | "NotSenior" | "Above 60" | "Below 60";
  gender?: "Male" | "Female";
  email?: string;
  phone?: string;
  isPlayer: boolean;
  isCaptain: boolean;
  isOwner: boolean;
  isCoreMember: boolean;
  isShortListed: boolean;
}

export interface Invitation {
  id: string;
  emailSentAt: string;
  recipientEmail: string;
  status: string;
  lastUpdated: string;
  title: string;
  firstName: string;
  lastName: string;
  profilePicture: string;
  inviteFor: string;
}
export interface Team {
  id: string;
  name: string;
  logo: string;
  captain?: PlayerDetailsViewOnly;
  playersColl: PlayerDetailsViewOnly[];
  coreMembersColl: PlayerDetailsViewOnly[];
  shortlistedPlayersColl: PlayerDetailsViewOnly[];
  seasonId: string;
  ownersColl: UserDetailsViewOnly[];
  members: TeamMember[];

  teamSponsors: SeasonSponsor[];
  teamHandicap: number;
  teamRank: number;
  status: string;
  invitationDetails: {
    avalaibleInvites: number;
    pendingInvites: number;
    invitations: Invitation[];
  };
}
